import { SVGProps } from 'react';

export interface IconDollarGradientProps extends SVGProps<SVGSVGElement> {
	className?: string;
	testId?: string;
}

const IconDollarGradient = (props: IconDollarGradientProps) => {
	const { testId = 'IconDollarGradient', className, ...remainingProps } = props;

	return (
		<svg
			data-testid={testId}
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 48 48"
			aria-label="Dollar Sign Icon"
			{...remainingProps}
		>
			<path
				d="M24 7.5C14.8875 7.5 7.5 14.8875 7.5 24C7.5 33.1125 14.8875 40.5 24 40.5C33.1125 40.5 40.5 33.1125 40.5 24C40.5 14.8875 33.1125 7.5 24 7.5ZM24 10.5C31.4557 10.5 37.5 16.5443 37.5 24C37.5 31.4557 31.4557 37.5 24 37.5C16.5443 37.5 10.5 31.4557 10.5 24C10.5 16.5443 16.5443 10.5 24 10.5ZM23.9517 16.2656C23.6877 16.2656 23.5122 16.4324 23.5122 16.7227V17.8213C21.0605 17.9443 19.3022 19.3156 19.3022 21.4336C19.3022 23.3326 20.5593 24.3607 22.8618 24.8789L23.5122 25.0283V28.2275C22.4045 28.1308 21.8511 27.6298 21.5698 26.9443C21.3238 26.4343 20.9549 26.1533 20.4097 26.1533C19.6889 26.1533 19.2583 26.5838 19.2583 27.2168C19.2583 27.3833 19.2933 27.568 19.3638 27.7705C19.7943 29.0538 21.2532 30.0993 23.5122 30.2051V31.2773C23.5122 31.5676 23.6877 31.7329 23.9517 31.7329C24.2157 31.7329 24.3911 31.5661 24.3911 31.2759V30.2036C26.9224 30.0544 28.7417 28.7096 28.7417 26.4858C28.7417 24.5613 27.4849 23.5946 25.0767 23.0493L24.3911 22.8999V19.8062C25.2349 19.9209 25.7886 20.3525 26.1313 21.0732C26.4126 21.5832 26.7902 21.8379 27.3354 21.8379C28.0037 21.8379 28.4429 21.4596 28.4429 20.8799C28.4429 20.6954 28.4075 20.5192 28.355 20.3438C27.9335 18.9908 26.4829 17.9623 24.3911 17.8213V16.7227C24.3911 16.4332 24.2157 16.2656 23.9517 16.2656ZM23.5122 19.7988V22.6992C22.2815 22.3827 21.7632 21.9168 21.7632 21.2051C21.7632 20.4933 22.361 19.9046 23.5122 19.7988ZM24.3911 25.2305C25.7974 25.5815 26.2903 25.9775 26.2896 26.7598C26.2896 27.5683 25.6571 28.1308 24.3911 28.2275V25.2305Z"
				fill="url(#icon_dollar_gradient)"
			/>
			<defs>
				<linearGradient
					id="icon_dollar_gradient"
					x1="17.5192"
					y1="-24.125"
					x2="66.4458"
					y2="0.162363"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FB923C" />
					<stop offset="0.5" stopColor="#EC4899" />
					<stop offset="1" stopColor="#0EA5E9" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default IconDollarGradient;
